import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Message",
  "use": "Message-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"Message\">\n    <g id=\"Message_Iconography\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M18,0 L2,0 C0.8954305,0 0,0.8954305 0,2 L0,20 L4,16 L18,16 C19.1045695,16 20,15.1045695 20,14 L20,2 C20,0.89 19.1,0 18,0 Z\" id=\"Message_Chat\" fill=\"currentColor\" fill-rule=\"nonzero\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol